import { ReactNode } from "react"

type Props = {
  children: ReactNode
  onClick?: () => void
}

export function TopnavProfileButton({
  children,
  onClick,
}: Props) {
  return (
    <button
      onClick={onClick}
      className="
        relative
        flex items-center justify-center
        w-9 h-9
        rounded-[.7rem]
        //bg-black/30
        hover:bg-white/10
        //border border-white/20
        border border-[var(--soft-border)] bg-[var(--soft-bg)]
        backdrop-blur-xl
        opacity-90 text-[var(--primary-color)]
        active:scale-95
        transition-all
      "
    >
      {children}
    </button>
  )
}